import { FiArrowUpRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const RedirectComponent: React.FC<React.PropsWithChildren<{ redirectTo: string; className?: string }>> = ({
  redirectTo,
  ...props
}) => {
  return (
    <>
      <Link to={redirectTo} className="">
        {props.children ? (
          props?.children
        ) : (
          <span
            data-tooltip-id="redirect_to_customer_profile"
            data-tooltip-content="Redirect to customer profile"
            className="text-blue-500 text-xl "
          >
            <FiArrowUpRight />
          </span>
        )}
      </Link>
      <Tooltip id="redirect_to_customer_profile" style={{ fontSize: "10px" }} />
    </>
  );
};

export default RedirectComponent;
